"use client";

import { useEffect, useState } from "react";
import {
  initFirebase,
  // initAppCheck,
  crashlyticsOptions,
} from '../lib/firebase';
import { FirebaseCrashlytics } from '@firebase/crashlytics/react';
import { FirebaseApp } from "@firebase/app";

export default function FirebaseProvider() {
  const [app, setApp] = useState<FirebaseApp | null>(null);

  useEffect(() => {
    const app = initFirebase();
    setApp(app);
    // initAppCheck();
  }, []);

  return (
    <>
      {app && (
        <FirebaseCrashlytics
          firebaseApp={app}
          crashlyticsOptions={crashlyticsOptions}
        />
      )}
    </>
  );
}